"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var validate = function (file) {
    var isNotNull = file !== null;
    var isAnObject = typeof file === 'object';
    var hasSize = file && file.size > 0;
    var isValidType = file && ['image/jpeg', 'image/gif', 'image/png'].includes(file.type);
    return isNotNull && isAnObject && hasSize && isValidType;
};
var create = function (bytes, type, name) {
    try {
        return new File(bytes, name, { type: type });
    }
    catch (error) {
        var blob = new Blob(bytes, { type: type });
        blob.name = name;
        var now = Date.now();
        blob.lastModified = now;
        blob.lastModifiedDate = new Date(now);
        return blob;
    }
};
exports.default = {
    create: create,
    validate: validate,
};
